'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
// List of available tracking events
var TRACK_PAGEVIEW = exports.TRACK_PAGEVIEW = 'pageview';
var TRACK_VARIANT_SELECTED = exports.TRACK_VARIANT_SELECTED = 'variantSelected';
var TRACK_VIEW_CONTENT = exports.TRACK_VIEW_CONTENT = 'viewContent';
var TRACK_PURCHASE = exports.TRACK_PURCHASE = 'purchase';
var TRACK_ADD_TO_CART = exports.TRACK_ADD_TO_CART = 'addToCart';
var TRACK_ADD_TO_WISHLIST = exports.TRACK_ADD_TO_WISHLIST = 'addToWishlist';
var TRACK_INITIATED_CHECKOUT = exports.TRACK_INITIATED_CHECKOUT = 'initiatedCheckout';
var TRACK_COMPLETED_REGISTRATION = exports.TRACK_COMPLETED_REGISTRATION = 'completedRegistration';
var TRACK_SEARCH = exports.TRACK_SEARCH = 'search';
var TRACK_SCROLL_TOP = exports.TRACK_SCROLL_TOP = 'scrollTop';
var TRACK_ADDED_PAYMENT_INFO = exports.TRACK_ADDED_PAYMENT_INFO = 'addedPaymentInfo';
var TRACK_SELECTED_PAYMENT_INFO = exports.TRACK_SELECTED_PAYMENT_INFO = 'selectedPaymentInfo';
var TRACK_SMARTBANNER = exports.TRACK_SMARTBANNER = 'smartbanner';
var TRACK_FILTER_LIVE_SUGGEST = exports.TRACK_FILTER_LIVE_SUGGEST = 'filterLiveSuggest';
var TRACK_QR_SCANNER = exports.TRACK_QR_SCANNER = 'qrScanner';
var TRACK_AD_SCANNER = exports.TRACK_AD_SCANNER = 'adScanner';
var TRACK_CC_SCANNER = exports.TRACK_CC_SCANNER = 'ccScanner';
var TRACK_OPEN_DEEP_LINK = exports.TRACK_OPEN_DEEP_LINK = 'openDeepLink';
var TRACK_OPEN_UNIVERSAL_LINK = exports.TRACK_OPEN_UNIVERSAL_LINK = 'openUniversalLink';
var TRACK_OPEN_DEFERRED_DEEP_LINK = exports.TRACK_OPEN_DEFERRED_DEEP_LINK = 'openDeferredDeepLink';
var TRACK_OPEN_SMART_APP_DOWNLOAD_LINK = exports.TRACK_OPEN_SMART_APP_DOWNLOAD_LINK = 'openSmartAppDownloadLink';
var TRACK_OPEN_PUSH_NOTIFICATION = exports.TRACK_OPEN_PUSH_NOTIFICATION = 'openPushNotification';
var TRACK_APP_REVIEW_PROMPT = exports.TRACK_APP_REVIEW_PROMPT = 'appReviewPrompt';
var TRACK_SET_CAMPAIGN_WITH_URL = exports.TRACK_SET_CAMPAIGN_WITH_URL = 'setCampaignWithUrl';
var TRACK_LOGIN_SUCCESS = exports.TRACK_LOGIN_SUCCESS = 'loginSuccess';
var TRACK_LOGIN_FAILED = exports.TRACK_LOGIN_FAILED = 'loginFailed';
var TRACK_CUSTOM_EVENT = exports.TRACK_CUSTOM_EVENT = 'customEvent';
var REMOVE_TRACKER = exports.REMOVE_TRACKER = 'removeTracker';
var ADD_TRACKER = exports.ADD_TRACKER = 'addTracker';

var scannerEvents = exports.scannerEvents = {
  // Scan type is activated
  SCAN_ACTIVATED: 'scan_activated',
  // The actual scan stated (for QR scanner same as activated)
  SCAN_STARTED: 'scan_started',
  // Scanning process cancelled
  SCAN_CANCELED: 'scan_canceled',
  // Scan ended with success
  SCAN_SUCCESS: 'scan_success',
  // Scan ended with no result
  SCAN_FAIL: 'scan_fail',
  // User interact with scanning result (click on link)
  SCAN_USER_LINK_INTERACTION: 'scan_user_link_interaction'
};

var customEvents = exports.customEvents = [TRACK_SMARTBANNER, TRACK_FILTER_LIVE_SUGGEST, TRACK_QR_SCANNER, TRACK_AD_SCANNER, TRACK_CC_SCANNER, TRACK_SCROLL_TOP, TRACK_OPEN_DEEP_LINK, TRACK_OPEN_UNIVERSAL_LINK, TRACK_OPEN_DEFERRED_DEEP_LINK, TRACK_OPEN_SMART_APP_DOWNLOAD_LINK, TRACK_OPEN_PUSH_NOTIFICATION, TRACK_APP_REVIEW_PROMPT, TRACK_CUSTOM_EVENT];

exports.default = [TRACK_PAGEVIEW, TRACK_VIEW_CONTENT, TRACK_VARIANT_SELECTED, TRACK_PURCHASE, TRACK_ADD_TO_CART, TRACK_ADD_TO_WISHLIST, TRACK_INITIATED_CHECKOUT, TRACK_COMPLETED_REGISTRATION, TRACK_SEARCH, TRACK_SCROLL_TOP, TRACK_ADDED_PAYMENT_INFO, TRACK_SELECTED_PAYMENT_INFO, TRACK_SMARTBANNER, TRACK_FILTER_LIVE_SUGGEST, TRACK_QR_SCANNER, TRACK_AD_SCANNER, TRACK_CC_SCANNER, TRACK_OPEN_DEEP_LINK, TRACK_OPEN_UNIVERSAL_LINK, TRACK_OPEN_DEFERRED_DEEP_LINK, TRACK_OPEN_SMART_APP_DOWNLOAD_LINK, TRACK_OPEN_PUSH_NOTIFICATION, TRACK_APP_REVIEW_PROMPT, TRACK_SET_CAMPAIGN_WITH_URL, REMOVE_TRACKER, ADD_TRACKER, TRACK_LOGIN_SUCCESS, TRACK_LOGIN_FAILED, TRACK_CUSTOM_EVENT];


// WEBPACK FOOTER //
// ./~/@shopgate/tracking-core/helpers/events.js